export default __webpack_public_path__ + "locales/cs/Settings.json?hash=bbafc88183d34f4c6738f07108f28ab2";